import { Button, Form, Input, Space } from "antd";
import { useEffect } from "react";
import CustomModal from "../../../../components/ui/CustomModal";
import { useUpdateBatchNameMutation } from "../../../../features/portal/batch/batchApi";
import useError from "../../../../hooks/useError";
import { toast } from "../../../../lib/toast";

type Props = {
  open: boolean;
  handleClose: (val?: any) => void;
  data: any;
};

export default function BatchEditModal({ open, handleClose, data }: Props) {
  const [form] = Form.useForm();

  const [updateBatchName, { isSuccess, isError, error, isLoading }] =
    useUpdateBatchNameMutation();

  useError(isError, error, "Batch name updated fail");

  const onFinish = (values: any) => {
    const newData = {
      name: values?.name,
    };
    updateBatchName({
      id: data?.id,
      data: newData,
    });
  };

  useEffect(() => {
    if (isSuccess) {
      handleClose();
      toast("success", "Batch name updated successfully");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return (
    <>
      <CustomModal
        width={500}
        title="Batch Edit"
        open={open}
        handleClose={handleClose}
        footer={null}
      >
        <Form
          className="custom-form"
          layout="vertical"
          requiredMark="optional"
          size="large"
          onFinish={onFinish}
          form={form}
          initialValues={{
            name: data?.batchName,
          }}
        >
          <Form.Item
            label="Batch Name"
            name="name"
            rules={[
              {
                required: true,
                message: "Please enter the disbursement batch name",
              },
            ]}
          >
            <Input placeholder="Enter disbursement batch name" />
          </Form.Item>

          <Space className="w-full mt-7" size={12}>
            <Button
              className="normal-dark-button modal-button"
              onClick={handleClose}
              size="middle"
            >
              Cancel
            </Button>
            <Button
              size="middle"
              type="primary"
              className="modal-button"
              htmlType="submit"
              loading={isLoading}
            >
              Update
            </Button>
          </Space>
        </Form>
      </CustomModal>
    </>
  );
}
